import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import HowItWorks from './components/HowItWorks';
import FeaturedMentors from './components/FeaturedMentors';
import FeaturedCourses from './components/FeaturedCourses';
import HomeTestimonials from './components/HomeTestimonials';
import CtaSection from './components/CtaSection';

const HomePage = () => (
  <div className="min-h-screen font-sans">
    <Navbar />
    <main>
      <HeroSection />
      <StatsBar />
      <HowItWorks />
      <FeaturedCourses />
      <FeaturedMentors />
      <HomeTestimonials />
      <CtaSection />
    </main>
    <Footer />
  </div>
);

export default HomePage;
